<template>
  <v-layout>
    <v-list>
      <v-list two-line subheader>
        <v-subheader class="mt-3 grey--text text--darken-1">식당 리스트</v-subheader>
        <RestaurantList></RestaurantList>
      </v-list>
      <v-list-tile v-if="isAuthenticated" @click="openAddRestaurant">
        <v-list-tile-action>
          <v-icon color="grey darken-1">add</v-icon>
        </v-list-tile-action>
        <v-list-tile-title class="grey--text text--darken-1">식당 추가</v-list-tile-title>
      </v-list-tile>
      <v-divider></v-divider>
      <!-- <v-list subheader>
        <v-subheader class="mt-3 grey--text text--darken-1">설정</v-subheader>
        <v-list-tile  v-if="isAuthenticated==false" @click="loginPressed">
          <v-list-tile-avatar>
            <v-icon>person</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="grey--text text--darken-1" >로그인</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="isAuthenticated"  @click="logoutPressed">
          <v-list-tile-avatar>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-if="isAuthenticated" class="grey--text text--darken-1">로그아웃</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>        
        <v-list-tile  @click="showOpenchatRoom">
          <v-list-tile-avatar>
            <v-icon>chat</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title class="grey--text text--darken-1">앱 피드백 오픈채팅방</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider> -->
      <!-- <v-list-tile>
        <a href="https://itunes.apple.com/kr/app/%EB%88%88%ED%8C%85%EB%B2%A0%EC%8A%A4%ED%8A%B8/id1206791137?mt=8"><img class="store-link-icon" src="../assets/ic_badge_appstore_kr.png" alt=""></a>
      </v-list-tile> -->

      <!-- <v-subheader class="mt-3 grey--text text--darken-1">추가기능</v-subheader>
        <v-list-tile  @click="showFoodMenuGenerator">
          <v-list-tile-avatar>
            <v-icon>attach_file</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="grey--text text--darken-1">식단 자동생성하기</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   
        <v-list-tile  @click="showFoodMenuGenerator">
          <v-list-tile-avatar>
            <v-icon>feedback</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="grey--text text--darken-1">영양사 피드백 & 공유</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
      <!-- <v-divider></v-divider> -->
      <!-- <v-subheader class="mt-3 grey--text text--darken-1">사용자용 어플</v-subheader>
        <v-list-tile>
          <a target="_blank"  href="https://play.google.com/store/apps/details?id=com.yunziri.foodnote"><img class="store-link-icon"
              src="../assets/ic_badge_googleplay_kr.png" alt=""></a>
        </v-list-tile>
        <v-list-tile>
          <a target="_blank"  href="https://itunes.apple.com/kr/app/%EA%B5%AC%EB%82%B4%EC%8B%9D%EB%8B%B9-%EC%8B%9D%EB%8B%A8%ED%91%9C-%EB%AA%A8%EB%93%A0-%EA%B5%AC%EB%82%B4%EC%8B%9D%EB%8B%B9-%EB%A9%94%EB%89%B4%EB%A5%BC-%EB%AA%A8%EC%9C%BC%EA%B3%A0-%EC%9E%88%EC%8A%B5%EB%8B%88/id1438202648?l=ko&ls=1&mt=8"><img class="store-link-icon"
              src="../assets/ic_badge_appstore_kr.png" alt=""></a>
        </v-list-tile>         -->
      <v-list-tile>
        <v-list-tile-avatar></v-list-tile-avatar>
        <v-list-tile-title class="grey--text text--darken-1">식단표장인 &copy; {{ new Date().getFullYear()
          }}</v-list-tile-title>
      </v-list-tile>
      <!-- </v-list> -->
    </v-list>

    <v-dialog v-model="addRestaurantdialog" width="600px">
      <restaurant-add-modal :dialog.sync="addRestaurantdialog"></restaurant-add-modal>
    </v-dialog>

  </v-layout>
</template>

<script>
import RestaurantList from "@/components/RestaurantList.vue";
import store from "@/store.js";

import RestaurantAddModal from "@/components/RestaurantAddModal";


export default {
  store,
  data: () => ({
    drawer: null,
    addRestaurantdialog: false,

  }),
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated;
    }
  },
  components: {
    RestaurantList,
    RestaurantAddModal,

  },
  methods: {
    openAddRestaurant: function () {
      this.addRestaurantdialog = true;
    },

    showFoodMenuGenerator: () => {
      alert("작업중입니다");
    },

  }
};
</script>
<style>
.store-link-icon {
  width: 80%;
}
</style>